import { QConfigStructureCategory, QConfigStructureType } from '@exam-management/graphql';
import { Box, Flex, Grid, SectionTitle, Text } from '@shared/components';
import { useMemo } from 'react';

import { TimeLimitInformation } from '../../components';
import { useQSetReviewSubtask } from '../../providers';
import { formatPassingCriteria, getRandomConfigType } from '../../utils';

export default function PassingCriteriaDetails() {
  const { subtaskDetails } = useQSetReviewSubtask();
  const { metadata, structures = [], fullScore = 0 } = subtaskDetails.qSet.qConfig;

  const { passingCriteria, randomConfig, timeLimit } = metadata;

  const filteredStructures = useMemo(
    () =>
      structures.filter(
        (structure) =>
          structure.type === QConfigStructureType.QBankStructureLevelItem &&
          structure.category === QConfigStructureCategory.Part &&
          structure.passingCriteria !== null,
      ),
    [structures],
  );

  const randomConfigType = getRandomConfigType(randomConfig);

  return (
    <Flex sx={(theme) => ({ gap: theme.spacing(4), flexDirection: 'column' })}>
      <SectionTitle title='ข้อมูลเกณฑ์การผ่าน' />
      <Grid
        sx={(theme) => ({
          gridTemplateColumns: `160px 1fr`,
          gap: theme.spacing(4),
          '> :nth-of-type(even)': {
            wordBreak: 'break-word',
          },
          fontSize: theme.typography.body2.fontSize,
        })}
      >
        <Text variant='body1Semibold'>เกณฑ์การผ่าน</Text>
        <Text>
          คะแนนรวมทั้งหมด:{' '}
          {passingCriteria ? formatPassingCriteria(passingCriteria, fullScore) : '-'}
        </Text>
        {filteredStructures.length ? (
          <Grid
            sx={(theme) => ({
              gridTemplateColumns: 'max-content 1fr',
              gap: theme.spacing(0, 1),
              gridColumn: '2 / 3',
            })}
          >
            <Text>หมวดที่บังคับ:</Text>
            {filteredStructures.map((structure) => (
              <Text key={structure.id} sx={{ gridColumn: '2 / 3' }}>
                {`${structure?.name}  ${structure?.passingCriteria ? formatPassingCriteria(structure.passingCriteria, structure.score) : '-'}`}
              </Text>
            ))}
          </Grid>
        ) : null}
        <Text variant='body1Semibold'>ระยะเวลาทำข้อสอบ</Text>
        <Box>
          <TimeLimitInformation timeLimit={timeLimit} structures={structures} />
        </Box>
        <Text variant='body1Semibold'>รูปแบบการสุ่มคำถาม</Text>
        <Text>{randomConfigType}</Text>
      </Grid>
    </Flex>
  );
}
